import api from "../index";

export const AddLicenseApi = (data) => api.post("add-plan", data);
export const EditLicenseApi = (data) => api.post("update-plan", data);
export const ChangePlanStatus = (data) => api.post("change-plan-status",data);
export const DeletePlan = (data) => api.post("delete-plan",data);
